import { AlertIcon, Button, Flex, Typography } from '@iheartjane/reefer';

import { RateAndReviewModal } from '../rateAndReviewModal/rateAndReviewModal';

interface RetryableProps {
  isRetryable?: true;
  /** Shows spinner while the review is resubmitted */
  isSubmitting?: boolean;
  /** Resubmits the form values */
  onRetry: () => void;
}

interface NonRetryableProps {
  isRetryable: false;
  onClose: () => void;
}

export type ReviewSubmitFailedProps = (RetryableProps | NonRetryableProps) & {
  testId?: string;
};

export function ReviewSubmitFailed({
  testId = 'review-submit-failed',
  ...props
}: ReviewSubmitFailedProps) {
  const isRetryable = props.isRetryable !== false;

  return (
    <>
      <RateAndReviewModal.Body>
        <Flex
          alignItems="center"
          data-testid={testId}
          flexDirection="column"
          height="100%"
          justifyContent="center"
          width="100%"
        >
          <Flex
            alignItems="center"
            justifyContent="center"
            background="error-light"
            borderRadius="xl"
            height={64}
            width={64}
          >
            <AlertIcon size="lg" />
          </Flex>
          <Typography
            as="h2"
            branded
            mt={8}
            textAlign="center"
            variant="h2-semibold"
          >
            Something went wrong
          </Typography>
          <Typography mt={8} textAlign="center">
            {isRetryable
              ? "We couldn't submit your review. Try again in a moment."
              : "We couldn't submit your review."}
          </Typography>
        </Flex>
      </RateAndReviewModal.Body>
      <RateAndReviewModal.Footer>
        {isRetryable ? (
          <Button
            label="Try again"
            loading={props.isSubmitting}
            onClick={props.onRetry}
          />
        ) : (
          <Button label="Close" onClick={props.onClose} />
        )}
      </RateAndReviewModal.Footer>
    </>
  );
}
